import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CenterPanel from './centerPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

function CancelConsultNowInvitationContainer(props) {
  const selectedConsultNowCaller = useSelector((state) => state.waitingAreaReducer.selectedConsultNowCaller);
  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader
        title={APP.LANGUAGE.CancelConsultNowInvitation.Title}
        subtitle={props.waitingArea.name}
        hideHelp={true}
      />
      <div className="content">
        <CenterPanel waitingArea={props.waitingArea} selectedConsultNowCaller={selectedConsultNowCaller} />
      </div>
    </Modal>
  );
}

export default CancelConsultNowInvitationContainer;
